export const EMAIL_REGEX = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

export const EXTERNAL_NUMBER_REGEX = !/^[\d()\+]+$/i;
